import * as CONF from '../../config/index';
import DEPLOYMENT from '../../constants/deployment.const';

const determineProductionConfiguration = () => CONF.ENVIRONMENT === DEPLOYMENT.prod;

// noinspection JSUnusedGlobalSymbols
export default determineProductionConfiguration;
